<template>
    <table class="table table-sm table-bordered">
        <thead>
            <tr>
                <th class="w-50">Durum</th>
                <th class="w-50">Son Güncelleme Tarihi</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <template v-if="businessAgreement.BES">
                    <td>
                        <span class="text-success font-weight-bolder">Aktif</span>
                    </td>
                </template>
                <template v-else>
                    <td>
                        <span class="text-success font-weight-bolder">Pasif</span>
                    </td>
                </template>
                <td>{{checkDate}}</td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'
import moment from 'moment'

export default {
    components:{
        BFormCheckbox
    },
    props:{
        businessAgreement:Object,
    },
    computed:{
        checkDate(){
            if(this.businessAgreement.BES){
                return moment(this.businessAgreement.BESLastCheck,'YYYY-MM-DDTHH:mm').format('DD.MM.YYYY')
            } else return null 
        }
    }
}
</script>

<style>

</style>